<!-- Modal di gestione delle notifiche degli utenti-->
<template>
    <b-modal
      :visible="visible" 
      @hidden="hide" 
      @change="change"
      @show="getUserInfo"
      :hide-footer="footer_hide"
      ok-only
      ref="modal"
      id="modal-remove-cu"
      :title="$t('manage_notification_modal.title')"
      :ok-title="$t('manage_notification_modal.save')"
      :cancel-title="$t('settings.cancel')"
      @ok="saveNotificationsSettings"
    >
      <div>
        <b>{{$t("manage_notification_modal.user_profile")}}</b>
      </div>
      <hr>
      <div><i style="color:#0090CD;" class="fa fa-user pr-1 pt-1 fa-1x pull-left title"></i>{{this.userName}} {{this.userSurname}}</div> 
      <div class="pb-5"><i style="color:#0090CD;" class="fa fa-envelope pr-1 pt-1 fa-1x pull-left title"></i>{{this.userMail}}</div>  
    
      <div>
        <b>{{$t("manage_notification_modal.settings")}}</b>
      </div>
      <hr>
      <div>
        <b-form-checkbox class="pb-3" v-model="checked_automatic_test" name="check-button" switch>
          <div class="float-left">{{$t("manage_notification_modal.automatic_test")}}</div>
        </b-form-checkbox>
        <b-form-checkbox class="pb-3" v-model="checked_com_24h" name="check-button" switch>
          <div class="float-left">{{$t("manage_notification_modal.com_24h")}}</div>
        </b-form-checkbox>
        <b-form-checkbox class="pb-3" v-model="checked_error" name="check-button" switch>
          <div class="float-left">{{$t("manage_notification_modal.error")}}</div>
        </b-form-checkbox>
      </div>
      
    </b-modal>
</template>

<script>

export default {
  name: "ManageUserNotifications",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    user: {
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    plant:{
      default: null
    }
  },
  data() {
    return {
      
      //notification check box
      checked_automatic_test:false,
      checked_com_24h:false,
      checked_error:false,

      //data user
      userName:"",
      userSurname:"",
      userMail:"",
      footer_hide: false,
    };
  },
   
  methods: {
    hide() {
      this.$emit("hide");
    },
    change(visible) {
      this.$emit("change", visible);
    },
    getUserInfo(){
      console.log("User",this.user);
      console.log("Plant",this.plant);
      this.userName=this.user.name;
      this.userSurname=this.user.surname;
      this.userMail=this.user.username;

      var userNotif=null;

      this.plant.plant_users.forEach(userInPlant => {
        if(userInPlant.userid==this.user.id)
            userNotif=userInPlant.notifications;
      });

      if (userNotif !=null)
      {
        userNotif.automatic_test=="true"? this.checked_automatic_test=true:this.checked_automatic_test=false;
        userNotif.com_24h=="true"? this.checked_com_24h=true:this.checked_com_24h=false;
        userNotif.functional_errors=="true"? this.checked_error=true:this.checked_error=false;         
      }
      else
      {
        this.checked_automatic_test=true;
        this.checked_com_24h=false;
        this.checked_error=false;
      }

    },
    saveNotificationsSettings() {
      
      var notifications={};
      notifications.automatic_test=this.checked_automatic_test.toString();
      notifications.com_24h=this.checked_com_24h.toString();
      notifications.functional_errors=this.checked_error.toString();
 
      this.$store.dispatch("dbSaveNotificationsOnProfile", {
          plantId: this.plant.id,
          userId: this.user.id,
          notifications: notifications
        });
  
    }
  },
};
</script>
